import {
  TextareaAutosize,
  TextareaAutosizeProps,
} from "@mui/base/TextareaAutosize";
import clsx from "clsx";
import { TextareaHTMLAttributes } from "react";
import React from "react";

import styles from "./TextArea.module.scss";

type TextAreaProps = {
  maxRows?: string | number;
  minRows?: string | number;
  resize?: boolean;
  minSymbolsLength?: number;
  maxSymbolsLength?: number;
  errorMessage?: string;
  errorClassName?: string;
  currentSymbolsLength?: number;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

const TextArea = React.forwardRef(function TextareaAutosizeCustom(
  props: TextareaAutosizeProps & { ownProps?: TextAreaProps },
  ref: React.ForwardedRef<HTMLTextAreaElement>,
) {
  const { ownProps, ...other } = props;

  return (
    <div className={styles.wrap}>
      <TextareaAutosize
        className={clsx(
          styles.textarea,
          ownProps?.resize && styles.resize,
          ownProps?.errorMessage && styles.error,
        )}
        ref={ref}
        {...other}
      />

      {ownProps?.maxSymbolsLength && (
        <div className={styles.count}>
          {ownProps?.currentSymbolsLength}/{ownProps.maxSymbolsLength}
        </div>
      )}

      {ownProps?.errorMessage && (
        <div className={clsx(styles.errorMessage, ownProps.errorClassName)}>
          {ownProps.errorMessage}
        </div>
      )}
    </div>
  );
});

export default TextArea;
